module.exports = __webpack_public_path__ + "img/playersGroup_p.21345d38.svg";